import { render, staticRenderFns } from "./Cookies_policy.vue?vue&type=template&id=7fa20a8c&scoped=true"
import script from "./Cookies_policy.vue?vue&type=script&lang=js"
export * from "./Cookies_policy.vue?vue&type=script&lang=js"
import style0 from "./Cookies_policy.vue?vue&type=style&index=0&id=7fa20a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa20a8c",
  null
  
)

export default component.exports